import React, { useEffect, useState } from 'react';
import authApi from '../../auth.api';
import { GET_USER_YOUTUBE_INFO } from '../../route';
import { toast } from 'react-toastify';
import YoutubeIcon from "../../YoutubeIcon";

const LinkYoutube = ({ handleLinkYoutube, youtubeLinked }) => {
  const [youTubeInfo, setYoutubeInfo] = useState(null);

  const fetchYoutubeInfo = async () => {
    const result = await authApi.get(GET_USER_YOUTUBE_INFO);
    if (result.status === false) {
      setYoutubeInfo(null);
      return toast.error(result.message);
    } else {
      setYoutubeInfo(result.data.youTubeInfo);
    }
  };

  useEffect(() => {
    fetchYoutubeInfo();
  }, []);

 return <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 rounded-lg border border-gray-100 space-y-4 sm:space-y-0'>
    <div className='flex items-start space-x-3 w-full sm:w-auto'>
      <YoutubeIcon className='h-5 w-5 mt-1 flex-shrink-0' />
      <div className='flex-grow min-w-0'>
        <h3 className='text-lg font-semibold text-gray-800 truncate'>
          YouTube
        </h3>
        {youtubeLinked && youTubeInfo && youTubeInfo.name && (
            <p className='text-sm text-gray-600 truncate'>{youTubeInfo.name}</p>
        )}
        <p className='text-sm text-gray-500'>
          {youtubeLinked ? 'Account linked' : 'Not linked'}
        </p>
      </div>
    </div>
    <button
        onClick={handleLinkYoutube}
        disabled={youtubeLinked}
        className={`w-full sm:w-auto px-4 py-2 rounded-md whitespace-nowrap ${
            youtubeLinked
                ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                : 'bg-indigo-600 text-white hover:bg-indigo-700'
        }`}
    >
      {youtubeLinked ? 'Linked' : 'Link Account'}
    </button>
  </div>
};

export default LinkYoutube;
